import { styled } from "@mui/styles";
import { Stack } from "@mui/material";

export const StyledChooseImageStack = styled(Stack)(({ theme }) => ({
    flexDirection: 'row !important',
    flexWrap: 'wrap',
    justifyContent: 'space-between',

    '& .ImageContainer': {
        maxHeight: '230px',
        width: 'calc(50% - 12px)',
        marginBottom: '15px',

        [theme.breakpoints.down('md')]: {
            minHeight: '80px',
            height: 'unset',
        },

        '& span': { height: '100%', width: '100%' },

        '& img': { height: '100%', width: '100%', objectFit: 'cover' },
    }
}))